"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiError = void 0;
class ApiError extends Error {
  constructor(code, message, friendlyMessage) {
    let content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    super(content || message);
    this.code = code;
    this.name = 'ApiError';
    this.friendlyMessage = friendlyMessage || message;
  }
}
exports.ApiError = ApiError;
//# sourceMappingURL=ApiError.js.map